import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ColumnChooserService, FilterService, GridModule, PageService, ResizeService, SortService } from '@syncfusion/ej2-angular-grids';
import { NgSelectModule } from '@ng-select/ng-select';
import { MaskedTextBoxModule, NumericTextBoxAllModule, NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { NgxUiLoaderModule } from 'ngx-ui-loader';

import { TaxsComponent } from './taxs/taxs.component';
import { RelationshipListComponent } from './relationship-list/relationship-list.component';
import { TaxsPercentComponent } from './taxs-percent/taxs-percent.component';

import { TaxsDetailsComponent } from './taxs-details.component';
import { TaxDetailsRoutingModule } from './taxs-details-routing.module';
import { MyDatePickerModule } from 'mydatepicker';
@NgModule({
  declarations: [TaxsComponent, TaxsDetailsComponent, RelationshipListComponent, TaxsPercentComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    NgSelectModule,
    NumericTextBoxModule,
    NumericTextBoxAllModule,
    MyDatePickerModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    TaxDetailsRoutingModule,
  ],
  providers: [ColumnChooserService, PageService, SortService, FilterService, ResizeService],
})
export class TaxDetailsModule { }
